import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName'
})
export class FullNamePipe implements PipeTransform {

  transform(value: FullNameBuildable): string {
    if (value.firstName === undefined || value.lastName === undefined) {
      console.warn('FullNamePipe: Missing firstName or lastName property for value:', value);
    }
    return (value.firstName ? value.firstName + ' ' : '') + (value.lastName ? value.lastName : '').trim();
  }

}

export type FullNameBuildable = {
  firstName?: string;
  lastName?: string;
}
